var map = {
	"./restaurant1.jpg": 5176,
	"./restaurant10.jpg": 4305,
	"./restaurant11.jpg": 4945,
	"./restaurant12.jpg": 6155,
	"./restaurant13.jpg": 8551,
	"./restaurant14.jpg": 9457,
	"./restaurant15.jpg": 8982,
	"./restaurant16.jpg": 1825,
	"./restaurant17.jpg": 3382,
	"./restaurant18.jpg": 1973,
	"./restaurant19.jpg": 1807,
	"./restaurant2.jpg": 3381,
	"./restaurant20.jpg": 3145,
	"./restaurant21.jpg": 5382,
	"./restaurant22.jpg": 7623,
	"./restaurant23.jpg": 5216,
	"./restaurant24.jpg": 9607,
	"./restaurant25.jpg": 4836,
	"./restaurant26.jpg": 1251,
	"./restaurant27.jpg": 3762,
	"./restaurant28.jpg": 6937,
	"./restaurant29.jpg": 1980,
	"./restaurant3.jpg": 4422,
	"./restaurant30.jpg": 9750,
	"./restaurant31.jpg": 4793,
	"./restaurant32.jpg": 6994,
	"./restaurant33.jpg": 8903,
	"./restaurant34.jpg": 932,
	"./restaurant35.jpg": 2647,
	"./restaurant36.jpg": 4835,
	"./restaurant37.jpg": 2471,
	"./restaurant38.jpg": 8042,
	"./restaurant39.jpg": 1135,
	"./restaurant4.jpg": 1217,
	"./restaurant40.jpg": 1853,
	"./restaurant41.jpg": 6751,
	"./restaurant42.jpg": 8193,
	"./restaurant43.jpg": 7873,
	"./restaurant44.jpg": 6031,
	"./restaurant45.jpg": 9925,
	"./restaurant46.jpg": 5161,
	"./restaurant47.jpg": 6581,
	"./restaurant48.jpg": 445,
	"./restaurant49.jpg": 3270,
	"./restaurant5.jpg": 1993,
	"./restaurant50.jpg": 385,
	"./restaurant51.jpg": 4282,
	"./restaurant52.jpg": 6748,
	"./restaurant53.jpg": 8290,
	"./restaurant54.jpg": 8460,
	"./restaurant55.jpg": 2164,
	"./restaurant56.jpg": 6032,
	"./restaurant57.jpg": 5127,
	"./restaurant58.jpg": 7978,
	"./restaurant59.jpg": 6942,
	"./restaurant6.jpg": 7012,
	"./restaurant60.jpg": 2686,
	"./restaurant61.jpg": 6736,
	"./restaurant62.jpg": 8297,
	"./restaurant63.jpg": 2324,
	"./restaurant64.jpg": 5604,
	"./restaurant65.jpg": 5885,
	"./restaurant66.jpg": 4674,
	"./restaurant67.jpg": 5536,
	"./restaurant68.jpg": 8228,
	"./restaurant69.jpg": 9290,
	"./restaurant7.jpg": 4690,
	"./restaurant70.jpg": 7370,
	"./restaurant71.jpg": 2339,
	"./restaurant72.jpg": 1513,
	"./restaurant73.jpg": 619,
	"./restaurant74.jpg": 5023,
	"./restaurant75.jpg": 9916,
	"./restaurant76.jpg": 307,
	"./restaurant77.jpg": 5714,
	"./restaurant78.jpg": 1344,
	"./restaurant8.jpg": 3370,
	"./restaurant9.jpg": 2757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8696;